var map = {
	"./approve.json": "56bc",
	"./delete.json": "fa0c",
	"./error.json": "bbea",
	"./no-notifications.json": "79db",
	"./reject.json": "ed67",
	"./something-went-wrong.json": "3bbd",
	"./success.json": "c452"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "76e6";